export default value => ({
  'data-testid': value,
});
